const accountingSystemOptions: { [key: string]: string } = {
  Sage: 'Sage',
  QuickBooks: 'QuickBooks',
  TurnKey: 'TurnKey',
};

export default accountingSystemOptions;
